import type { MapTheme, Tile } from "@dailywars/core/engine";
import { isBridgeRoadTile } from "@dailywars/core/render/roadTerrainBackground";

import { drawTerrainTile } from "#/game/terrainTileDraw";

export function drawRoadTerrainBackground({
  ctx,
  tiles,
  width,
  x,
  y,
  theme,
  tileSize,
}: {
  ctx: CanvasRenderingContext2D;
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
  theme?: MapTheme;
  tileSize: number;
}): void {
  const kind = isBridgeRoadTile({ tiles, width, x, y }) ? "sea" : "plain";
  drawTerrainTile({ ctx, kind, x, y, theme, tileSize, tiles, width });
}
